import { transition } from '@helpers/animate';
import { imageCoverContainer } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { baseGrid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { h1, paragraphLarge } from '@helpers/typography';
import { ButtonStyles } from '@stories/Components/Buttons/GeneralButton/Button.styles';
import ScrollIndictatorStyles from '@stories/Components/General/ScrollIndictator/ScrollIndictator.styles';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Global/SectionWrapper/SectionWrapper.styles';
import { parseToHsl } from 'polished';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --topSpacing: 200px;
  --highlightColour: ${parseToHsl(brand.secondary.red).hue}
    ${parseToHsl(brand.secondary.red).saturation * 100}%
    ${parseToHsl(brand.secondary.red).lightness * 100}%;

  position: relative;
  overflow: hidden;

  ${SectionWrapperStyles.Inner},
  ${SectionWrapperStyles.SiteWide} {
    height: 100%;
  }

  ${SectionWrapperStyles.SiteWide} {
    ${baseGrid};

    padding-top: var(--topSpacing);
  }

  ${ScrollIndictatorStyles.Container} {
    display: none;
  }

  @media ${from(Device.TabletLarge)} {
    ${SectionWrapperStyles.SiteWide} {
      padding-top: 0;
    }

    &[data-has-image='true'] {
      height: 100vh;
    }

    ${ScrollIndictatorStyles.Container} {
      display: inline-block;
      margin: ${fluid(28, 34)} 0 0;
    }
  }
`;
const Image = styled.img `
  ${imageCoverContainer()};
`;
const ContentWrapper = styled.div `
  position: relative;
  z-index: 1;
  display: flex;
  grid-column: 1 / span 12;
  grid-row: 2 / span 1;

  @media ${from(Device.TabletLarge)} {
    grid-column: 1 / span 7;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 1 / span 6;
  }
`;
const ContentInner = styled.div `
  margin: auto 0 0 calc(var(--sitePadding) * -1);
  background-color: var(--bgColour);
  padding: ${fluid(20, 46)} var(--sitePadding);
  width: 100%;

  ${ButtonStyles.Button} {
    margin: ${fluid(16, 24)} 0 0;
  }

  @media ${from(Device.TabletLarge)} {
    margin-left: 0;
    padding-left: ${fluid(26, 152, Device.Desktop)};
    padding-right: ${fluid(26, 152, Device.Desktop)};
    padding-bottom: ${fluid(20, 64, Device.Desktop)};
  }
  &[data-has-image='false']{
    @media ${from(Device.TabletLarge)} {
      margin-top: 250px;
    }
  }
`;
const Title = styled.h1 `
  ${h1};

  ${Container}[data-has-image='false'] & {
    > span {
      ${transition('background-size', 0.5)};

      color: transparent;
      background: var(--fgColour);
      background-image: linear-gradient(to right, ${brand.secondary.red}, ${brand.secondary.red});
      background-repeat: no-repeat;
      background-size: 100% 100%;
      -webkit-background-clip: text;
      background-clip: text;
      transition-delay: 0.05s;

      @media ${from(Device.TabletLarge)} {
        transition-duration: 0.5s;
      }

      @media ${from(Device.Desktop)} {
        transition-delay: 0.25s;
      }
    }
  }

  ${Container}[data-animate='false'] & {
    > span {
      background-size: 0% 100%;
    }
  }
`;
const Content = styled.div `
  ${paragraphLarge};

  margin: 0;
`;
const BeamWrapper = styled.div `
  ${transition('opacity', 0.35)};

  grid-column: 1 / span 12;
  grid-row: 1 / span 2;
  pointer-events: none;
  position: relative;
  z-index: 1;

  ${Container}[data-animate='false'] & {
    opacity: 0;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 1 / span 11;
  }
`;
const LightBeam = styled.div `
  ${transition('transform', 1)};

  height: calc(100% + var(--topSpacing));
  margin-top: calc(var(--topSpacing) * -1);
  width: 100%;
  background: transparent;
  background-image: linear-gradient(
    to right,
    transparent calc(100% - 54px),
    hsla(var(--highlightColour) / 0.33) calc(100% - 16px),
    hsla(var(--highlightColour) / 0.6) calc(100% - 1px),
    hsla(var(--highlightColour) / 0.8) 100%
  );
  background-repeat: no-repeat;
  background-size: 100% 100%;

  ${Container}[data-has-image='true'] & {
    display: none;
  }

  ${Container}[data-animate='false'] & {
    transform: translateX(calc((100% - 4px) * -1));
  }

  @media ${until(Device.Desktop)} {
    width: calc(100% + (var(--sitePadding) * 2));
    margin-left: calc(var(--sitePadding) * -1);
  }

  @media ${from(Device.Desktop)} {
    height: 100%;
    margin-top: 0;
  }

  @media ${from(Device.Desktop)} {
    transition-duration: 2.6s;
  }
`;
const InnerPageBannerStyles = {
    Container,
    Image,
    ContentWrapper,
    ContentInner,
    Title,
    Content,
    LightBeam,
    BeamWrapper,
};
export default InnerPageBannerStyles;
